import { api } from './api-client';
import type { UserProfile, OnboardingData, ProfileUpdateData } from '@/types/user.types';

export type { UserProfile, OnboardingData, ProfileUpdateData };

class UserService {
  async getUserProfile(signal?: AbortSignal): Promise<UserProfile> {
    return api.get<UserProfile>('/users/me', { signal });
  }

  async completeOnboarding(data: OnboardingData, signal?: AbortSignal): Promise<UserProfile> {
    // Transform camelCase to snake_case for backend
    const payload = {
      display_name: data.displayName,
      school_name: data.schoolName,
      grade_levels: data.gradeLevels,
      subjects: data.subjects,
    };
    return api.post<UserProfile>('/users/onboarding', payload, { signal });
  }

  async updateProfile(data: ProfileUpdateData, signal?: AbortSignal): Promise<{ success: boolean }> {
    // Transform camelCase to snake_case for backend
    const payload: Record<string, unknown> = {};

    if (data.displayName !== undefined) {
      payload.display_name = data.displayName;
    }
    if (data.schoolName !== undefined) {
      payload.school_name = data.schoolName;
    }
    if (data.gradeLevels !== undefined) {
      payload.grade_levels = data.gradeLevels;
    }
    if (data.subjects !== undefined) {
      payload.subjects = data.subjects;
    }

    return api.put<{ success: boolean }>('/users/me', payload, { signal });
  }
}

export const userService = new UserService();
